import React from "react";
import { List, Datagrid, TextField, DateField } from "react-admin";
import { withStyles } from '@material-ui/core/styles';
import { styleList } from "../style";
import { compose } from "redux";
import Pagination from "../Pagination";
import { withTranslation } from "react-i18next";

const arrayColumn = [
    { source: 'id', label: 'ID' },
    { source: 'message', label: 'Message' },
    { source: 'url', label: 'URL' },
    { source: 'clientIp', label: 'IP' },
    { source: 'createdAt', label: 'Created At' },
];

export const ClientErrorList = compose(withStyles(styleList), withTranslation())(({ classes, t, ...props }) => {
    const { tReady, ...newProps } = props;
    return (
        <List {...newProps} perPage={25} pagination={<Pagination {...newProps} />} className={classes.listWrapper}>
            <Datagrid className={classes.tableWrapper} rowClick="show">
                <TextField source="id" />
                <TextField source="message" />
                <TextField source="url" />
                <TextField source="clientIp" />
                <DateField source="createdAt" showTime />
            </Datagrid>
        </List>
    );
});
